/* eslint-disable max-len */
import { IDENTITY_TYPE_BRN, IDENTITY_TYPE_MILITARY, IDENTITY_TYPE_NRIC, IDENTITY_TYPE_PASSPORT } from './defaultIdentityTypeOpts';

const BOOKING_STATUSES_TIN_VALIDATION = [
  { text: 'Booked and Sold', value: 'booked_and_sold', name: 'booked_and_sold' },
  { text: 'Sold', value: 'sold', name: 'sold' },
];
export default BOOKING_STATUSES_TIN_VALIDATION;

export const PUBLIC_GENERIC_TIN = 'EI00000000010';
export const FOREIGN_BUYER_GENERIC_TIN = 'EI00000000020';
export const FOREIGN_SUPPLIER_GENERIC_TIN = 'EI00000000030';
export const GOVERNMENT_GENERIC_TIN = 'EI00000000040';

export const GENERIC_TIN_MAP = [
  { idType: IDENTITY_TYPE_NRIC, genericTin: PUBLIC_GENERIC_TIN, isForeignEntity: false, autofill: false },
  { idType: IDENTITY_TYPE_PASSPORT, genericTin: FOREIGN_BUYER_GENERIC_TIN, isForeignEntity: true, autofill: true },
  { idType: IDENTITY_TYPE_PASSPORT, genericTin: FOREIGN_SUPPLIER_GENERIC_TIN, isForeignEntity: true, autofill: false },
  { idType: IDENTITY_TYPE_MILITARY, genericTin: PUBLIC_GENERIC_TIN, isForeignEntity: false, autofill: false },
  { idType: IDENTITY_TYPE_BRN, genericTin: '', isForeignEntity: false, autofill: true },
  { idType: IDENTITY_TYPE_BRN, genericTin: FOREIGN_BUYER_GENERIC_TIN, isForeignEntity: true, autofill: true },
  { idType: IDENTITY_TYPE_BRN, genericTin: FOREIGN_SUPPLIER_GENERIC_TIN, isForeignEntity: true, autofill: false },
  // { idTypes: [], tin: 'EI00000000040' }, // will add back when idType for government is identified
];

export const GENERIC_TIN_VALUES = GENERIC_TIN_MAP.map(e => e.genericTin);
export const LOCAL_GENERIC_TIN_LIST = [PUBLIC_GENERIC_TIN, GOVERNMENT_GENERIC_TIN];
export const FOREIGN_GENERIC_TIN_LIST = [FOREIGN_BUYER_GENERIC_TIN, FOREIGN_SUPPLIER_GENERIC_TIN];

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
export const isForeignIdType = (idType, isForeignCompany) => {
  if (idType === IDENTITY_TYPE_BRN) {
    return isForeignCompany;
  }
  return GENERIC_TIN_MAP.some(e => e.isForeignEntity && e.idType === idType);
};

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
export const getAutoFillTin = (idType, isForeignCompany) => {
  if (idType === IDENTITY_TYPE_BRN) {
    const tin = GENERIC_TIN_MAP.find(e => e.idType === idType && e.isForeignEntity === isForeignCompany);
    return tin && tin.autofill ? tin.genericTin : '';
  }
  const tin = GENERIC_TIN_MAP.find(e => e.idType === idType && e.autofill);
  return tin ? tin.genericTin : '';
};

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
export const getGenericTinByIdTypeAndTinNo = (idType, tin, isForeignCompany) => {
  if (idType === IDENTITY_TYPE_BRN) {
    return GENERIC_TIN_MAP.filter(tinType => tinType.idType === idType && tinType.genericTin === tin && tinType.isForeignEntity === isForeignCompany);
  }
  return GENERIC_TIN_MAP.filter(tinType => tinType.idType === idType && tinType.genericTin === tin);
};

export const isGenericTinFound = (genericTinList = []) => genericTinList.length > 0;

export const GENERIC_TIN_UNMATCHED_ERROR_MSG = 'The Generic TIN you entered doesn’t match the selected ID type';



// WEBPACK FOOTER //
// ./src/constants/tin.js